<template>
  <div
    class="ctc-format"
    role="group"
    aria-labelledby="ctc-widget-format-label"
  >
    <strong id="ctc-widget-format-label" class="ctc-format__label">
      Format
    </strong>
    <rmr-segmented-control
      :value="value"
      :items="formats"
      size="sm"
      aria-label="Format du widget Affilizz"
      @input="$emit('input', $event)"
    />
    <small class="ctc-format__hint">{{ hint }}</small>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

import RmrSegmentedControl from "@/components/ui/actions/RmrSegmentedControl.vue";

import { WIDGET_FORMATS } from "../constants";

/** Compact RMR choice. The product presentation below explains it. */
export default {
  name: "CtcWidgetFormatPicker",
  components: { RmrSegmentedControl },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: String,
      default: "BOX",
    },
  },
  setup(props) {
    return {
      // What the chosen format does for the reader, beside the toggle.
      hint: computed(() => {
        const format =
          WIDGET_FORMATS.find((item) => item.value === props.value) ||
          WIDGET_FORMATS[0];
        return `${format.name} : ${format.description}`;
      }),
      formats: WIDGET_FORMATS.map((format) => ({
        value: format.value,
        label: format.value,
        title: `${format.value} — ${format.name}. ${format.description}`,
      })),
    };
  },
};
</script>

<style lang="scss" scoped>
.ctc-format {
  display: flex;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 12px;
}

.ctc-format__hint {
  min-width: 0;
  color: $rmr-text-secondary;
  font-size: $rmr-fs-base;
}

.ctc-format__label {
  color: $rmr-text-primary;
  font-size: $rmr-fs-base;
  font-weight: 700;
  white-space: nowrap;
}
</style>
